/*
  "Is this a gift?" in the tote (snippets/mm-cart-gift.liquid).

  The answer is saved on the cart as attributes, which show on the order page in the
  admin under Additional details:
    Gift = Yes · Gift recipient · Gift note
  Switching the option off clears all three.

  The drawer is re-rendered from Shopify's section response after every cart change,
  so the markup is always rebuilt from cart.attributes in Liquid. Text saves never
  re-render anything: they are debounced (600 ms), sent on blur, and flushed before
  the page goes away. The only thing kept in memory is what the shopper typed in this
  page view, so that a re-render caused by something else (a quantity change, an offer)
  cannot wipe a note that was still on its way to Shopify.

  Dawn's cart-drawer-items listens for "change" on everything inside it and treats the
  target as a quantity input, so change events from this panel are stopped here.

  Optional paid gift wrap (theme setting mm_gift_wrap_product): the tick box adds or
  removes that product's first variant as a line with the hidden property
  _mm_source = gift-wrap, then repaints the tote. Switching the gift option off takes
  the wrap out as well. A tote left with nothing but gift wrap has the wrap removed.

  Events on document, for other workstreams that fill [data-mm-gift-extra]:
    mm:gift:ready   detail { root, slot, on, context }   each time a panel connects
    mm:gift:change  detail { on, recipient, note }       after each successful save
  Customer event for the custom pixel: gift_option { on, context, has_recipient,
  has_note, wrap }. The note itself is never sent to analytics.

  Words: status messages come from the <script data-mm-i18n> block inside the panel
  (locale keys under mm.gift), read again every time one is written because the tote is
  re-rendered after each change. English below is the fallback. The order note mirror
  (GIFT ORDER, For, Note) is for the packing team, not shoppers, and stays fixed because
  the snippet recognises its own note by that marker.
*/
(function (root) {
  var MAX_RECIPIENT = 40;
  var MAX_NOTE = 200;
  var SAVE_DELAY = 600;
  var NOTE_MARKER = 'GIFT ORDER';
  var KEY_GIFT = 'Gift';
  var KEY_RECIPIENT = 'Gift recipient';
  var KEY_NOTE = 'Gift note';

  /* ---------- Pure helpers (tested offline with node, see test/mm-cart-gift.mjs) ---------- */

  /* Trim to the same length the maxlength attribute allows, without cutting an emoji in half. */
  function clip(text, max) {
    var s = String(text == null ? '' : text);
    if (s.length <= max) return s;
    s = s.slice(0, max);
    var last = s.charCodeAt(s.length - 1);
    if (last >= 0xD800 && last <= 0xDBFF) s = s.slice(0, -1);
    return s;
  }

  /* Tidy what goes on the order: no control characters, Unix line breaks, no run of blank lines. */
  function tidy(text, max, multiline) {
    var s = String(text == null ? '' : text).replace(/\r\n?/g, '\n');
    /* Control characters out (char codes below 32 other than the line break, and 127). */
    s = s.split('\t').join(' ').split('').filter(function (ch) {
      var code = ch.charCodeAt(0);
      return code === 10 || (code >= 32 && code !== 127);
    }).join('');
    if (multiline) {
      s = s.replace(/\n{3,}/g, '\n\n');
    } else {
      s = s.replace(/\n+/g, ' ');
    }
    return clip(s.trim(), max);
  }

  function normalise(state) {
    state = state || {};
    return {
      on: !!state.on,
      recipient: tidy(state.recipient, MAX_RECIPIENT, false),
      note: tidy(state.note, MAX_NOTE, true)
    };
  }

  /* The cart attributes for a state. Off clears all three keys. */
  function buildAttributes(state) {
    var s = normalise(state);
    var out = {};
    out[KEY_GIFT] = s.on ? 'Yes' : '';
    out[KEY_RECIPIENT] = s.on ? s.recipient : '';
    out[KEY_NOTE] = s.on ? s.note : '';
    return out;
  }

  /* The order note mirror, for the packing slip. Empty when the option is off. */
  function buildOrderNote(state) {
    var s = normalise(state);
    if (!s.on) return '';
    var lines = [NOTE_MARKER + ': no invoice in the parcel'];
    if (s.recipient) lines.push('For: ' + s.recipient);
    if (s.note) lines.push('Note: ' + s.note);
    return lines.join('\n');
  }

  /*
    Body for POST /cart/update.js.
    opts.mirrorNote   also write the order note (only while the theme's note box is off)
    opts.noteIsOurs   the note on the cart right now is one we wrote, so off may clear it
    opts.removeKey    line key of the gift wrap to take out in the same call
    opts.sections     section ids to get back for a repaint (only with removeKey)
  */
  function buildUpdateBody(state, opts) {
    opts = opts || {};
    var s = normalise(state);
    var body = { attributes: buildAttributes(s) };
    if (opts.mirrorNote && (s.on || opts.noteIsOurs)) body.note = buildOrderNote(s);
    if (opts.removeKey) {
      body.updates = {};
      body.updates[opts.removeKey] = 0;
      if (opts.sections && opts.sections.length) {
        body.sections = opts.sections;
        body.sections_url = opts.sectionsUrl || '/';
      }
    }
    return body;
  }

  /* Body for POST /cart/add.js when the gift wrap box is ticked. */
  function buildWrapAddBody(variantId, sections, sectionsUrl) {
    var body = { items: [{ id: Number(variantId), quantity: 1, properties: { _mm_source: 'gift-wrap' } }] };
    if (sections && sections.length) {
      body.sections = sections;
      body.sections_url = sectionsUrl || '/';
    }
    return body;
  }

  function counterText(length, max) {
    var used = Math.max(0, Math.min(length || 0, max));
    return used + ' / ' + max;
  }
  function remaining(length, max) {
    return Math.max(0, max - (length || 0));
  }
  function sameState(a, b) {
    var x = normalise(a);
    var y = normalise(b);
    return x.on === y.on && x.recipient === y.recipient && x.note === y.note;
  }

  var api = {
    MAX_RECIPIENT: MAX_RECIPIENT,
    MAX_NOTE: MAX_NOTE,
    clip: clip,
    tidy: tidy,
    normalise: normalise,
    buildAttributes: buildAttributes,
    buildOrderNote: buildOrderNote,
    buildUpdateBody: buildUpdateBody,
    buildWrapAddBody: buildWrapAddBody,
    counterText: counterText,
    remaining: remaining,
    sameState: sameState
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.mmCartGift = api;

  /* ---------- Browser only from here ---------- */
  if (typeof window === 'undefined' || typeof document === 'undefined' || !window.customElements) return;
  if (customElements.get('mm-cart-gift')) return;

  /* What the shopper entered in this page view. Liquid stays the source of truth on a fresh page. */
  var last = null;
  var timer = null;
  var inflight = null;
  var queued = false;
  var busy = false;
  var refocus = null;
  var passing = false;
  var instances = [];

  var FALLBACK = {
    saved: 'Saved',
    removed: 'Gift option removed',
    wrapAdded: 'Gift wrap added',
    wrapRemoved: 'Gift wrap removed',
    saveFailed: 'We couldn\'t save your note. Check your connection and try again.',
    updateFailed: 'We couldn\'t update your tote. Check your connection and try again.'
  };

  function decode(text) {
    if (text.indexOf('&') === -1) return text;
    var box = document.createElement('textarea');
    box.innerHTML = text;
    return box.value;
  }

  /* One message, read fresh from a gift panel on the page now. */
  function t(key) {
    var words = {};
    var block = document.querySelector('mm-cart-gift [data-mm-i18n]');
    if (block) { try { words = JSON.parse(block.textContent) || {}; } catch (e) { words = {}; } }
    var text = words[key];
    if (typeof text !== 'string' || !text || text.indexOf('translation missing') !== -1) text = FALLBACK[key] || '';
    return decode(text);
  }

  function cartUrl(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base + path;
  }

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* ignore */ }
  }

  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) { /* ignore */ }
  }

  function post(path, body, keepalive) {
    return fetch(cartUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      keepalive: !!keepalive
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (json) {
        if (!r.ok) throw new Error(json.description || json.message || 'cart update failed');
        return json;
      });
    });
  }

  /* Same sections, same repaint as assets/mm-cart-offers.js, so the tote looks the same whoever changed it. */
  function sectionsToRender() {
    var list = [];
    if (document.getElementById('CartDrawer')) list.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) list.push(items.dataset.id);
    if (footer && footer.dataset.id) list.push(footer.dataset.id);
    return list;
  }
  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }
  function paint(sections, itemCount) {
    sections = sections || {};
    var drawerEl = document.getElementById('CartDrawer');
    if (drawerEl && sections['cart-drawer']) {
      var fresh = parse(sections['cart-drawer']).getElementById('CartDrawer');
      if (fresh) {
        drawerEl.innerHTML = fresh.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof itemCount === 'number') drawer.classList.toggle('is-empty', itemCount === 0);
        var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
        if (drawer && overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var freshBubble = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    }
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
      var target = el.querySelector('.js-contents');
      var source = parse(sections[el.dataset.id]).querySelector('.js-contents');
      if (target && source) target.innerHTML = source.innerHTML;
    });
  }

  function say(text, tone) {
    instances.forEach(function (el) { el.say(text, tone); });
  }

  function options() {
    var el = instances[0];
    return {
      mirrorNote: !!el && el.dataset.mirrorNote === 'true',
      noteIsOurs: !!el && (el.dataset.noteOurs === 'true' || el.wroteNote === true)
    };
  }

  /* One save at a time. A change made while a save is in the air is sent straight after it. */
  function push(keepalive) {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!last) return Promise.resolve();
    if (inflight) { queued = true; return inflight; }
    var sent = normalise(last);
    var opts = options();
    inflight = post('cart/update.js', buildUpdateBody(sent, opts), keepalive)
      .then(function () {
        if (opts.mirrorNote && sent.on) instances.forEach(function (el) { el.wroteNote = true; });
        if (!queued) say(t(sent.on ? 'saved' : 'removed'), 'good');
        emit('mm:gift:change', sent);
        track('gift_option', {
          on: sent.on,
          context: (instances[0] && instances[0].dataset.context) || 'drawer',
          has_recipient: sent.recipient !== '',
          has_note: sent.note !== '',
          wrap: !!document.querySelector('[data-mm-gift-wrap]:checked')
        });
      })
      .catch(function () {
        say(t('saveFailed'), 'error');
      })
      .then(function () {
        inflight = null;
        if (queued) { queued = false; return push(keepalive); }
      });
    return inflight;
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; push(false); }, SAVE_DELAY);
  }

  function pending() {
    return !!timer || !!inflight;
  }

  class MmCartGift extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-mm-gift-switch]');
      this.panel = this.querySelector('[data-mm-gift-panel]');
      this.recipient = this.querySelector('[data-mm-gift-recipient]');
      this.note = this.querySelector('[data-mm-gift-note]');
      this.count = this.querySelector('[data-mm-gift-count]');
      this.status = this.querySelector('[data-mm-gift-status]');
      this.wrap = this.querySelector('[data-mm-gift-wrap]');
      this.slot = this.querySelector('[data-mm-gift-extra]');
      if (!this.toggle || !this.panel || this.ready) return;
      this.ready = true;
      if (instances.indexOf(this) === -1) instances.push(this);

      /* Keep Dawn's quantity handler away from these fields (see the note at the top). */
      this.addEventListener('change', function (event) { event.stopPropagation(); });

      this.toggle.addEventListener('change', this.onToggle.bind(this));
      if (this.recipient) {
        this.recipient.addEventListener('input', this.onType.bind(this));
        this.recipient.addEventListener('blur', this.onBlur.bind(this));
        this.recipient.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          if (this.note) this.note.focus();
        }.bind(this));
      }
      if (this.note) {
        this.note.addEventListener('input', this.onType.bind(this));
        this.note.addEventListener('blur', this.onBlur.bind(this));
      }
      if (this.wrap) this.wrap.addEventListener('change', this.onWrap.bind(this));

      /* What Liquid rendered is the truth, unless the shopper typed something newer in this page view. */
      var rendered = this.read();
      if (last && !sameState(last, rendered)) {
        this.write(last);
        if (!pending()) schedule();
      }
      this.updateCount();

      if (refocus && refocus.context === this.dataset.context) {
        var target = refocus.what === 'wrap' ? this.wrap : this.toggle;
        refocus = null;
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
      }

      /* A tote with nothing but gift wrap in it: take the wrap out. */
      if (this.dataset.wrapOnly === 'true' && this.wrap && this.wrap.dataset.lineKey && !busy) {
        this.changeWrap(false, true);
      }

      emit('mm:gift:ready', { root: this, slot: this.slot, on: this.toggle.checked, context: this.dataset.context });
    }

    disconnectedCallback() {
      var at = instances.indexOf(this);
      if (at !== -1) instances.splice(at, 1);
    }

    read() {
      return {
        on: this.toggle.checked,
        recipient: this.recipient ? this.recipient.value : '',
        note: this.note ? this.note.value : ''
      };
    }

    write(state) {
      this.toggle.checked = !!state.on;
      this.panel.hidden = !state.on;
      this.classList.toggle('is-on', !!state.on);
      if (this.recipient && document.activeElement !== this.recipient) this.recipient.value = state.recipient || '';
      if (this.note && document.activeElement !== this.note) this.note.value = state.note || '';
      this.updateCount();
    }

    /* The tote page has the drawer's copy of this panel as well: keep them in step. */
    mirror() {
      var self = this;
      instances.forEach(function (el) { if (el !== self) el.write(last); });
    }

    say(text, tone) {
      if (!this.status) return;
      this.status.textContent = text || '';
      this.status.dataset.tone = tone || 'info';
    }

    updateCount() {
      if (!this.count || !this.note) return;
      var max = parseInt(this.count.dataset.max, 10) || MAX_NOTE;
      var length = this.note.value.length;
      var left = remaining(length, max);
      this.count.textContent = counterText(length, max);
      this.count.classList.toggle('is-near', left <= 20);
      /* Quiet while typing; screen readers hear it only when the end is near. */
      if (left <= 20) this.count.setAttribute('aria-live', 'polite');
      else this.count.removeAttribute('aria-live');
    }

    onToggle() {
      last = this.read();
      this.write(last);
      this.mirror();
      if (last.on) {
        push(false);
        if (this.recipient) { try { this.recipient.focus({ preventScroll: true }); } catch (e) { this.recipient.focus(); } }
        return;
      }
      /* Off: clear the attributes, and take the gift wrap out in the same call if it is in the tote. */
      if (this.wrap && this.wrap.checked && this.wrap.dataset.lineKey) {
        this.changeWrap(false, false);
      } else {
        push(false);
      }
    }

    onType() {
      last = this.read();
      this.updateCount();
      this.say('', 'info');
      this.mirror();
      schedule();
    }

    onBlur() {
      if (!last) return;
      last = this.read();
      if (timer) push(true);
    }

    onWrap() {
      this.changeWrap(this.wrap.checked, false);
    }

    /*
      Adds or removes the gift wrap line, then repaints the tote. Removing also sends the
      current attributes, so "gift off" and "wrap out" are one call.
    */
    changeWrap(add, silent) {
      if (busy || !this.wrap) return;
      busy = true;
      if (timer) { clearTimeout(timer); timer = null; }
      last = this.read();
      this.classList.add('is-busy');
      var self = this;
      var context = this.dataset.context;
      var what = this.toggle.checked ? 'wrap' : 'switch';
      var sections = sectionsToRender();
      var url = window.location.pathname;
      var request = add
        ? post('cart/add.js', buildWrapAddBody(this.wrap.dataset.variantId, sections, url))
        : post('cart/update.js', buildUpdateBody(last, {
            mirrorNote: options().mirrorNote,
            noteIsOurs: options().noteIsOurs,
            removeKey: this.wrap.dataset.lineKey,
            sections: sections,
            sectionsUrl: url
          }));
      request.then(function (json) {
        if (!silent) refocus = { context: context, what: what };
        paint(json.sections, add ? 1 : json.item_count);
        if (!silent) say(t(add ? 'wrapAdded' : (last.on ? 'wrapRemoved' : 'removed')), 'good');
        if (!add) emit('mm:gift:change', normalise(last));
      }).catch(function (err) {
        self.wrap.checked = !add;
        var text = err && err.message && err.message !== 'cart update failed'
          ? err.message
          : t('updateFailed');
        self.say(text, 'error');
      }).then(function () {
        busy = false;
        self.classList.remove('is-busy');
      });
    }
  }

  customElements.define('mm-cart-gift', MmCartGift);

  /*
    Checkout pressed while a note is still on its way: hold the cart form for a moment
    (2.5 s at most), let the save land, then send the form on exactly as it was pressed.
    Anything unexpected lets the form through untouched; checkout is never blocked.
  */
  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      if (passing || !form || (form.id !== 'CartDrawer-Form' && form.id !== 'cart')) return;
      if (!pending()) return;
      event.preventDefault();
      /* Nothing else should see this first press; the real submit follows in a moment. */
      event.stopPropagation();
      var submitter = event.submitter || null;
      var done = false;
      var go = function () {
        if (done) return;
        done = true;
        passing = true;
        try {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitter);
          } else {
            if (submitter && submitter.name) {
              var hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = submitter.name;
              hidden.value = submitter.value || '';
              form.appendChild(hidden);
            }
            form.submit();
          }
        } finally {
          setTimeout(function () { passing = false; }, 0);
        }
      };
      setTimeout(go, 2500);
      push(true).then(go, go);
    } catch (e) { /* let the form go */ }
  }, true);

  /* Leaving the page with a save still waiting: send it now and let it finish in the background. */
  window.addEventListener('pagehide', function () {
    if (timer) push(true);
  });
})(typeof window !== 'undefined' ? window : globalThis);
